import { z } from 'zod';

import { zodContractItemsTableSearchSchema } from '../-searchParams';

export const zodContractSearchParamsSchema =
  zodContractItemsTableSearchSchema.extend({
    viewAttachmentId: z.uuid().optional().catch(undefined),
  });
